/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Giveawaystooltip2Inputs */

const id_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah total giveaway yang muncul di database`)
};

const ms_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah pemberian yang muncul dalam pangkalan data`)
};

const da_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlet antal giveaways der findes i databasen`)
};

const de_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtzahl der Giveaways in der Datenbank`)
};

const en_us2_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of giveaways that appear in the database`)
};

const es_es2_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número total de regalos que aparecen en la base de datos`)
};

const es_mx2_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número total de regalos que aparecen en la base de datos`)
};

const fil_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang bilang ng mga giveaway na lumalabas sa database`)
};

const fr_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre total de gratuités apparaissant dans la base de données`)
};

const it_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero totale di giveaway che appaiono nel database`)
};

const hu_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az adatbázisban megjelenő ajándékok teljes száma`)
};

const nl_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal aantal giveaways dat in de database voorkomt`)
};

const no_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antall giveaways som vises i databasen`)
};

const pl_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna liczba rozdań w bazie danych`)
};

const pt_br2_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of giveaways that appear in the database`)
};

const pt_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número total de ofertas grátis que aparecem na base de dados`)
};

const ro_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numărul total de oferte gratuite care apar în baza de date`)
};

const fi_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaisjakojen kokonaismäärä tietokannassa`)
};

const sv_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antal utlottningar i databasen`)
};

const vi_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng số lượt tặng miễn phí xuất hiện trong cơ sở dữ liệu`)
};

const tr_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veritabanında görünen toplam bedava oyun sayısı`)
};

const cs_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkový počet výprodejů v databázi`)
};

const bg_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общ брой безплатни игри, които се появяват в базата данни`)
};

const ru_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общее количество раздач в базе данных`)
};

const uk_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загальна кількість роздач у базі даних`)
};

const ar_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي عدد الهدايا التي تظهر في قاعدة البيانات`)
};

const hi_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेटाबेस में गिवअवे की कुल संख्या`)
};

const th_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จำนวนของแจกฟรีทั้งหมดที่ปรากฏในฐานข้อมูล`)
};

const ja_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データベースに表示される配布の総数`)
};

const zh_cn2_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of giveaways that appear in the database`)
};

const zh_hant1_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of giveaways that appear in the database`)
};

const ko_components_giveawaystats_giveawaystooltip2 = /** @type {(inputs: Components_Giveawaystats_Giveawaystooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of giveaways that appear in the database`)
};

/**
* | output |
* | --- |
* | "Total number of giveaways that appear in the database" |
*
* @param {Components_Giveawaystats_Giveawaystooltip2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_giveawaystooltip2 = /** @type {((inputs?: Components_Giveawaystats_Giveawaystooltip2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Giveawaystooltip2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "ms") return ms_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "da") return da_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "de") return de_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "fil") return fil_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "fr") return fr_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "it") return it_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "hu") return hu_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "nl") return nl_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "no") return no_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "pl") return pl_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "pt") return pt_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "ro") return ro_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "fi") return fi_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "sv") return sv_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "vi") return vi_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "tr") return tr_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "cs") return cs_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "bg") return bg_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "ru") return ru_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "uk") return uk_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "ar") return ar_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "hi") return hi_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "th") return th_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "ja") return ja_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_giveawaystooltip2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_giveawaystooltip2(inputs)
	return ko_components_giveawaystats_giveawaystooltip2(inputs)
});
export { components_giveawaystats_giveawaystooltip2 as "components.giveawayStats.giveawaysTooltip" }